import { useEffect, useRef, useState } from "react";
import "./pricingSection.css";

const useScrollVisible = (threshold = 0.15) => {
  const ref = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect();
        }
      },
      { threshold }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, [threshold]);

  return [ref, isVisible];
};

const INCLUDED_FEATURES = [
  "Full access to the Khor calculation engine",
  "Instant integration with your Excel models",
  "ARGUS Enterprise file import",
  "Monthly AI Model Builder credits",
  "Unlimited file sharing, even with people who don't have Khor",
];

const PricingSection = () => {
  const [ref, isVisible] = useScrollVisible();

  return (
    <section className="pricing-section" ref={ref}>
      <div className={`pricing-container is-fade ${isVisible ? "is-visible" : ""}`}>
        <p className="is-eyebrow">Pricing</p>
        <h2 className="is-headline">Simple pricing. No annual contract.</h2>

        <div className="pricing-card">
          <div className="pricing-price-row">
            <span className="pricing-price">$250</span>
            <span className="pricing-price-unit">/user/month</span>
          </div>
          <p className="pricing-billing-note">Billed monthly. Cancel anytime.</p>

          <p className="pricing-blurb">
            Try Khor on your next deal. If it's not the right fit, cancel. No year-long
            commitment.
          </p>

          <p className="pricing-included-label">Everything included:</p>
          <ul className="pricing-list">
            {INCLUDED_FEATURES.map((feature) => (
              <li key={feature}>{feature}</li>
            ))}
          </ul>

          <a href="/contact?requestType=Demo" className="btn-hero-primary pricing-cta">
            Book a Demo
          </a>
        </div>
      </div>
    </section>
  );
};

export default PricingSection;
